import { render, staticRenderFns } from "./NovedadCampana.vue?vue&type=template&id=298add06&scoped=true"
import script from "./NovedadCampana.vue?vue&type=script&lang=js"
export * from "./NovedadCampana.vue?vue&type=script&lang=js"
import style0 from "./NovedadCampana.vue?vue&type=style&index=0&id=298add06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298add06",
  null
  
)

export default component.exports